import { keyframes, styled } from 'styles';
import { StyledPlaceholderProps } from './types';

export const animation = keyframes`
  0% {
    background-position: -15em 0;
  }
  50%,
  100% {
    background-position: calc(100% + 15em) 0;
  }
`;

export const StyledPlaceholder = styled.div<StyledPlaceholderProps>`
  animation: ${animation} 2s ease-in-out infinite;
  background-color: ${({ theme }) => theme.placeholder.base};
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.placeholder.base},
    ${({ theme }) => theme.placeholder.highlight},
    ${({ theme }) => theme.placeholder.base}
  );
  background-repeat: no-repeat;
  background-size: 15em 100%;
  border-radius: ${({ theme }) => theme.radius.small};
  height: 1em;
  width: ${({ $width }) => $width}%;
`;

StyledPlaceholder.displayName = 'Placeholder.Styled';
